<template>
    <div>
        <OrganizationChart :value="data" :pt="{ node : { class : 'shadow-6 w-18rem h-16rem text-blue-900'}, lineDown : { class : 'shadow-6'}, lineCell: { class : 'border-blue-200'}, lines: { class : 'border-blue-200'}}">
            <template #person="slotProps">
                <div class="flex flex-column align-items-center justify-content-center h-full">
                    <div class="font-bold mb-2">{{ slotProps.node.data.name }}</div>
                    <img :alt="slotProps.node.data.name" :src="slotProps.node.data.image" class="mb-2 w-4rem border-circle fadein animation-duration-1000 grayscale" onerror="this.onerror=null; this.src='/assets/usuario-jerarquia.png';">
                    <div class="w-full" :class="{'border-top-1 border-gray-300 pt-1' : slotProps.node.data.puesto != 'AUXILIAR DE SOPORTE TECNICO'}" v-if="slotProps.node.data.puesto != 'AUXILIAR DE SOPORTE TECNICO'">{{ slotProps.node.data.puesto }}</div>
                    <div v-if="slotProps.node.data.correo" class="w-full" :class="{'border-top-1 border-gray-300 pt-1' : slotProps.node.data.puesto == 'AUXILIAR DE SOPORTE TECNICO'}"><a class="p-button-text" :href="`mailto:${slotProps.node.data.correo}`">{{ slotProps.node.data.correo }}</a></div>
                    <div v-if="slotProps.node.data.telefono">{{ slotProps.node.data.telefono }}</div>
                </div>
            </template>
            <template #default="slotProps">
                <span>{{ slotProps.node.label }}</span>
            </template>
        </OrganizationChart>
    </div>
</template>

<script>
import Empleados from '../service/Empleados';
export default {
    props: {
        empleadoSeleccionado: Object,
        empleadosSeleccionados: Array
    },
	data(){
		return {
			data: {
                key: '0',
                type: 'person',
                data: {
                    image: 'https://primefaces.org/cdn/primevue/images/avatar/amyelsner.png',
                    name: 'Amy Elsner',
                    title: 'CEO'
                },
                children: [
                ]
            },
            selection: {},
            jeraquias: [],
            empleados: [],
		};
	},
	components: {
    },
    methods: {
        getJerarquias(){
            let t = this;
            let serviceEmpleados =  new Empleados();
            serviceEmpleados.getJerarquia(t).then(res => {
                if(res){
                    this.jeraquias = res;
                    t.getEmpleadoInicial();
                }
            });
        },
        getEmpleados(){
            let t = this;
            let serviceEmpleados =  new Empleados();
            serviceEmpleados.getEmpleados(t).then(res => {
                if(res){
                    t.empleados = res;
                    t.getJerarquias();

                }
            });
        },

        async getEmpleadoInicial(){
            let t = this;
            let titular = this.empleadoSeleccionado?? this.empleados.find(e => e.Puesto == "Titular de la Coordinación de Informática");
            if(titular){
                this.data.key = titular.Matricula;
                this.data.type = 'person';
                this.data.data = {
                    image: `http://172.23.137.15/webaps/recursos/imagen/perfil/${titular.Matricula}.jpg`,
                    name: t.getFullName(titular),
                    puesto: titular.Puesto,
                    correo: titular.Correo_inst,
                    telefono: titular.Telefono
                };

                this.data.children = await t.getInferiores(titular)
                
            }
        },
        getFullName(data){
            return `${data.Ap_pat} ${data.Ap_mat} ${data.Nombres}`;
        },
        async getInferiores(data) {
            let t = this;

            let serviceEmpleados = new Empleados();
            let lacayos = await serviceEmpleados.getJerarquiaEmpleado(t, data.Matricula);

            let mapped = await Promise.all(lacayos.map(async (l) => {
                let empleado = t.empleados.find(em => em.Matricula == l.Matricula_inferior);
                return {
                    key: `${data.Matricula}_${l.Matricula_inferior}`,
                    type: 'person',
                    data: {
                        image: `http://172.23.137.15/webaps/recursos/imagen/perfil/${empleado.Matricula}.jpg`,
                        name: t.getFullName(empleado),
                        puesto: empleado.Puesto,
                        tipo_contratacion: empleado.Tipo_contratacion,
                        correo: empleado.Correo_inst,
                        telefono: empleado.Telefono
                    },
                    children: empleado.Puesto != 'AUXILIAR DE SOPORTE TECNICO' ? await t.getInferiores(empleado) : []
                };
            }));

            return mapped;
        }

    },
	computed: {

	},
    mounted(){
        if(this.empleadosSeleccionados?.length > 0){
            this.empleados = this.empleadosSeleccionados;
            this.getEmpleadoInicial();
        }else{
            this.getEmpleados();
        }
    },
    created(){
    }
}
</script>
<style>
    .p-organizationchart-line-right, .p-organizationchart-line-left, .p-organizationchart-line-top{
        border-color: var(--blue-800) !important;
        border-width: 2px !important;

    }

    .p-organizationchart-line-down {
        background: var(--blue-800) !important;
        width: 2px !important;
        translate: 2px;
    } 

    .grayscale {
        filter: grayscale(40%);
        border: 2px solid var(--blue-800);
    }

</style>